import type { Reel } from '../reel';

const reelItemPosition = 2;

export function scrollRight(e: React.UIEvent<HTMLButtonElement>) {
  const reel = e.currentTarget.parentElement?.childNodes.item(reelItemPosition)
    .firstChild as HTMLDivElement;
  const lastChild = reel.lastChild as HTMLDivElement;

  reel.insertBefore(reel.firstChild as HTMLDivElement, lastChild.nextSibling);
}

export function scrollLeft(e: React.UIEvent<HTMLButtonElement>) {
  const reel = e.currentTarget.parentElement?.childNodes.item(reelItemPosition)
    .firstChild as HTMLDivElement;
  const firstChild = reel.firstChild as HTMLDivElement;

  reel.insertBefore(reel.lastChild as HTMLDivElement, firstChild);
}

export function handleScroll(
  e: Parameters<NonNullable<React.ComponentProps<typeof Reel>['onScroll']>>[0],
) {
  if (
    e.currentTarget.scrollLeft + e.currentTarget.clientWidth + 1 >=
    e.currentTarget.scrollWidth
  ) {
    (
      e.currentTarget.parentElement?.parentElement
        ?.children[1] as HTMLButtonElement
    ).click();
    e.currentTarget.scrollLeft -= e.currentTarget.children[0].clientWidth;
  }

  if (e.currentTarget.scrollLeft === 0) {
    (
      e.currentTarget.parentElement?.parentElement
        ?.children[0] as HTMLButtonElement
    ).click();

    e.currentTarget.scrollLeft += e.currentTarget.children[0].clientWidth;
  }
}
